import { css } from '@emotion/css';

import { MAX_MENU_ITEMS, MENU_ITEM_HEIGHT, MENU_LIST_Y_PADDING } from './consts';

export const addMenu = css`
  width: 30rem;
  max-height: ${MAX_MENU_ITEMS * MENU_ITEM_HEIGHT + MENU_LIST_Y_PADDING}px;
  overflow-y: scroll;
`;
